import { type LinkProps, useNavigate } from '@tanstack/react-router'
import { useLayoutEffect } from 'react'

export interface UseRedirectParams {
  condition: boolean
  redirectTo: LinkProps['to']
}

/**
 * Redirect an user when a certain condition is evaluated to `true`
 *
 * @example
 * { condition: !loginToken, redirectTo: '/' } => An user will be redirected to the root page when not being signed in
 */
export const useRedirect = ({ condition, redirectTo }: UseRedirectParams) => {
  const navigate = useNavigate()

  useLayoutEffect(() => {
    if (condition) {
      void navigate({ to: redirectTo })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [condition])
}
